<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()" styleClass="shadow-2 my-3">
    <div class="fluid formgrid grid">
        <div class="flex flex-column gap-2 col-12 text-center">
            <p-progressSpinner></p-progressSpinner>
            <span class="text-lg">Chargement en cours...</span>
        </div>
    </div>
</p-card>

<!-- General Information Display (like items pattern) -->
<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <div class="flex align-items-center gap-4 mb-4">
                <div *ngIf="!isMobile"
                    class="w-6rem h-6rem bg-gray-100 border-round flex align-items-center justify-content-center">
                    <i class="pi pi-user text-gray-500 text-3xl"></i>
                </div>
                <div class="mt-2">
                    <div class="flex align-items-center gap-3 mb-1">
                        <h5 class="m-0">{{employe.prenom}} {{employe.nom}} ({{employe.noEmploye}})</h5>
                        <span [class]="'statut ' + employe.statut.nom.replace(' ','').toLowerCase()">
                            {{employe.statut.nom}}
                        </span>
                    </div>
                    <span class="text-lg mb-1">{{employe.courriel || 'Aucun courriel spécifié'}}</span>
                </div>
            </div>
            <p-menubar autoDisplay="false" [model]="menu">
                <div class="flex align-items-center gap-2">
                    <button *ngIf="modeConsultation()" pButton pRipple pTooltip="Modifier" icon="pi pi-pencil"
                        class="p-button-primary" (click)="btnModifier_click()"></button>
                    <button *ngIf="!modeConsultation()" pButton pRipple pTooltip="Enregistrer" icon="pi pi-check"
                        class="p-button-primary" (click)="sauvegarder()"></button>
                    <button *ngIf="!modeConsultation()" pButton pRipple pTooltip="Annuler" icon="pi pi-times"
                        class="p-button-outlined" (click)="annuler()"></button>
                </div>
            </p-menubar>
        </p-card>
    </div>
</div>

<!-- Tab View Section -->
<div *ngIf="EstCharge()" class="grid">
    <div class="col-12">
        <p-card>
            <p-tabView [scrollable]="true" [(activeIndex)]="tabIndex" orientation="left">

                <!-- General Information Tab -->
                <p-tabPanel>
                    <ng-template pTemplate="header">
                        <i class="pi pi-info-circle mr-2"></i>
                        <span>Informations générales</span>
                    </ng-template>
                    <div class="grid">

                        <!-- Left column - Personal Information -->
                        <div class="col-12 lg:col-6">
                            <p-card styleClass="h-full">
                                <h6 class="mb-4 text-primary-600 font-semibold">Informations personnelles</h6>
                                <div class="flex flex-column gap-4">
                                    <div class="flex flex-column gap-2">
                                        <label for="prenom" class="font-medium">Prénom<span
                                                class="requis text-danger">*</span></label>
                                        <span *ngIf="modeConsultation()" class="text-900">{{employe.prenom |
                                            valeurVide}}</span>
                                        <input *ngIf="!modeConsultation()" #prenomEmploye type="text" pInputText
                                            id="prenom" [(ngModel)]="employe.prenom" autocomplete="off"
                                            class="p-inputtext-sm" autofocus />
                                        <small class="p-error" *ngIf="submitted && !employe.prenom">Le prénom est
                                            obligatoire.</small>
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <label for="nom" class="font-medium">Nom</label>
                                        <span *ngIf="modeConsultation()" class="text-900">{{employe.nom |
                                            valeurVide}}</span>
                                        <input *ngIf="!modeConsultation()" #nomEmploye type="text" pInputText id="nom"
                                            [(ngModel)]="employe.nom" autocomplete="off" class="p-inputtext-sm" />
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <label for="courriel" class="font-medium">Courriel</label>
                                        <span *ngIf="modeConsultation()" class="text-900">{{employe.courriel |
                                            valeurVide}}</span>
                                        <input *ngIf="!modeConsultation()" type="text" pInputText id="courriel"
                                            [(ngModel)]="employe.courriel" class="p-inputtext-sm" autocomplete="off" />
                                        <small class="p-error" *ngIf="!validerCourrielHamel() && employe.courriel">Le
                                            courriel doit être un courriel hamelconstruction.com.</small>
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <label for="cellulaire" class="font-medium">Cellulaire</label>
                                        <span *ngIf="modeConsultation()" class="text-900">{{employe.cellulaire |
                                            valeurVide}}</span>
                                        <input *ngIf="!modeConsultation()" type="text" pInputText id="cellulaire"
                                            [(ngModel)]="employe.cellulaire" autocomplete="off"
                                            class="p-inputtext-sm" />
                                    </div>
                                </div>
                            </p-card>
                        </div>

                        <!-- Right column - Professional Information -->
                        <div class="col-12 lg:col-6">
                            <p-card styleClass="h-full">
                                <h6 class="mb-4 text-primary-600 font-semibold">Informations professionnelles</h6>
                                <div class="flex flex-column gap-4">
                                    <div class="flex flex-column gap-2">
                                        <label for="noEmploye" class="font-medium">No employé</label>
                                        <span *ngIf="modeConsultation()" class="text-900">{{employe.noEmploye |
                                            valeurVide}}</span>
                                        <input *ngIf="!modeConsultation()" type="text" pInputText id="noEmploye"
                                            [(ngModel)]="employe.noEmploye" autocomplete="off" class="p-inputtext-sm" />
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <label for="usagerCtrl" class="font-medium">Usager Ctrl</label>
                                        <span *ngIf="modeConsultation()" class="text-900">{{employe.usagerCtrl |
                                            valeurVide}}</span>
                                        <input *ngIf="!modeConsultation()" type="text" pInputText id="usagerCtrl"
                                            [(ngModel)]="employe.usagerCtrl" class="p-inputtext-sm"
                                            autocomplete="off" />
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <label for="initialesCtrl" class="font-medium">Initiales Ctrl</label>
                                        <span *ngIf="modeConsultation()" class="text-900">{{employe.initialesCtrl |
                                            valeurVide}}</span>
                                        <input *ngIf="!modeConsultation()" type="text" pInputText id="initialesCtrl"
                                            [(ngModel)]="employe.initialesCtrl" class="p-inputtext-sm"
                                            autocomplete="off" />
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <label class="font-medium">Paramètres</label>
                                        <div class="flex align-items-center gap-2">
                                            <p-checkbox *ngIf="!modeConsultation()" [binary]="true"
                                                [(ngModel)]="employe.indMecanique" inputId="indMecanique"></p-checkbox>
                                            <label for="indMecanique" class="font-medium ml-2">Employé lié à la
                                                mécanique</label>
                                            <div *ngIf="modeConsultation()"
                                                class="text-900 m-2 p-2 border-round font-bold">{{employe.indMecanique ?
                                                'Oui' : 'Non'}}</div>
                                        </div>
                                    </div>
                                </div>
                            </p-card>
                        </div>
                    </div>
                </p-tabPanel>

                <!-- Admin Role Management Tab (Only visible to admins) -->
                <p-tabPanel *ngIf="employe.employeId && estAutorise('employe_modifier')">
                    <ng-template pTemplate="header">
                        <i class="pi pi-shield mr-2"></i>
                        <span>Gestion des accès</span>
                    </ng-template>
                    <div class="grid">
                        <div class="col-12">
                            <div class="fluid formgrid grid">
                                <div class="col-12">
                                    <div class="flex align-items-center justify-content-center gap-2">
                                        <p-progressSpinner *ngIf="!rolesCharges"
                                            styleClass="w-2rem h-2rem mr-2"></p-progressSpinner>
                                        <span *ngIf="!rolesCharges" class="text-sm">Chargement des rôles...</span>
                                    </div>

                                    <div *ngIf="rolesEnErreur" class="flex flex-column">
                                        <p-messages severity="error" styleClass="w-full mb-4">
                                            <ng-template pTemplate>
                                                <div class="flex align-items-center w-full gap-4">
                                                    <i class="pi pi-exclamation-triangle text-2xl text-danger"></i>
                                                    <div>Impossible de charger les rôles de l'employé</div>
                                                    <small>Assurez vous que l'employé est bien enregistré dans
                                                        Auth0.</small>
                                                </div>
                                            </ng-template>
                                        </p-messages>
                                    </div>

                                    <div *ngIf="rolesCharges && !rolesEnErreur" class="flex flex-column">
                                        <div
                                            class="flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                                            <div class="flex align-items-center gap-2">
                                                <span class="p-input-icon-left">
                                                    <i class="pi pi-search"></i>
                                                    <input pInputText type="text" placeholder="Rechercher un rôle..."
                                                        (input)="filtrerRoles($event)" class="p-inputtext-sm" />
                                                </span>
                                            </div>
                                            <div class="flex align-items-center gap-2 flex-wrap">
                                                <button pButton pRipple type="button" label="Ajouter des rôles"
                                                    icon="pi pi-plus" class="p-button-primary p-button-sm"
                                                    (click)="ouvrirDialogueAjoutRoles()"></button>
                                                <button pButton pRipple type="button" label="Supprimer sélection"
                                                    icon="pi pi-trash" class="p-button-danger p-button-sm"
                                                    [disabled]="!rolesSelectionnes || rolesSelectionnes.length === 0"
                                                    (click)="confirmerSuppressionRoles()"></button>
                                            </div>
                                        </div>

                                        <p-table #dtRoles [value]="rolesEmploye" [rows]="10" [paginator]="true"
                                            [globalFilterFields]="['name', 'description']"
                                            [(selection)]="rolesSelectionnes" dataKey="roleId"
                                            styleClass="p-datatable-sm" [rowHover]="true" [showCurrentPageReport]="true"
                                            currentPageReportTemplate="{first} à {last} sur {totalRecords} rôles"
                                            [rowsPerPageOptions]="[10,25,50]">

                                            <ng-template pTemplate="header">
                                                <tr>
                                                    <th style="width: 3rem">
                                                        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                                    </th>
                                                    <th pSortableColumn="name">Nom <p-sortIcon
                                                            field="name"></p-sortIcon></th>
                                                    <th style="width: 8rem">Actions</th>
                                                </tr>
                                            </ng-template>

                                            <ng-template pTemplate="body" let-role>
                                                <tr>
                                                    <td>
                                                        <p-tableCheckbox [value]="role"></p-tableCheckbox>
                                                    </td>
                                                    <td>{{role.nom}}</td>
                                                    <td>
                                                        <button pButton pRipple icon="pi pi-list"
                                                            class="p-button-rounded p-button-info p-button-text mr-2"
                                                            pTooltip="Voir les tâches" (click)="voirTachesRole(role)"
                                                            [disabled]="!role.taches || role.taches.length === 0"></button>
                                                        <button pButton pRipple icon="pi pi-trash"
                                                            class="p-button-rounded p-button-danger p-button-text"
                                                            (click)="supprimerRole(role)"></button>
                                                    </td>
                                                </tr>
                                            </ng-template>

                                            <ng-template pTemplate="emptymessage">
                                                <tr>
                                                    <td colspan="4" class="text-center p-4">
                                                        <div class="flex flex-column align-items-center">
                                                            <i class="pi pi-shield text-500 text-4xl mb-3"></i>
                                                            <span>Aucun rôle attribué à cet employé</span>
                                                            <button pButton pRipple label="Ajouter des rôles"
                                                                icon="pi pi-plus" class="p-button-outlined mt-3"
                                                                (click)="ouvrirDialogueAjoutRoles()"></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-template>
                                        </p-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>

                <!-- Emprunts Tab -->
                <p-tabPanel leftIcon="pi pi-user">
                    <ng-template pTemplate="header">
                        <i class="pi pi-user mr-2"></i>
                        <span>Emprunts</span>
                        <div style="min-width: 2rem">
                            <p-badge *ngIf="empruntsEmploye && empruntsEmploye.length > 0"
                                [value]="empruntsEmploye.length" severity="info" styleClass="ml-2 relative"></p-badge>
                        </div>
                    </ng-template>

                    <div class="grid">
                        <div class="col-12">
                            <div class="flex justify-content-between align-items-center mb-3">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text"
                                        (input)="dtEmprunts.filterGlobal($event.target.value, 'contains')"
                                        placeholder="Rechercher..." />
                                </span>
                            </div>
                            <p-table [value]="empruntsEmploye" [loading]="chargementEmprunts" [paginator]="true"
                                [rows]="10" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} emprunts"
                                [globalFilterFields]="['item.numero', 'item.description', 'item.categorie.nom', 'statut.nom']"
                                #dtEmprunts>

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="item.numero">
                                            Numéro <p-sortIcon field="item.numero"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="item.description">
                                            Description <p-sortIcon field="item.description"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="item.categorie.nom">
                                            Catégorie <p-sortIcon field="item.categorie.nom"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="dateAffectation">
                                            Date d'affectation <p-sortIcon field="dateAffectation"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="dateRetour">
                                            Date de retour <p-sortIcon field="dateRetour"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="statut.nom">
                                            Statut <p-sortIcon field="statut.nom"></p-sortIcon>
                                        </th>
                                        <th>Actions</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-emprunt>
                                    <tr>
                                        <td>{{ emprunt.item?.numero }}</td>
                                        <td>{{ emprunt.item?.description }}</td>
                                        <td>{{ emprunt.item?.categorie?.nom }}</td>
                                        <td>{{ emprunt.dateAffectation | date:'dd/MM/yyyy HH:mm' }}</td>
                                        <td>
                                            <span *ngIf="emprunt.dateRetour; else nonRetourne">
                                                {{ emprunt.dateRetour | date:'dd/MM/yyyy HH:mm' }}
                                            </span>
                                            <ng-template #nonRetourne>
                                                <i class="pi pi-minus text-500"></i>
                                            </ng-template>
                                        </td>
                                        <td>
                                            <p-tag [value]="emprunt.statut?.nom"
                                                [severity]="getStatutSeverity(emprunt.statut?.nom)"></p-tag>
                                        </td>
                                        <td>
                                            <p-button icon="pi pi-eye" size="small"
                                                [routerLink]="['/emprunt', emprunt.empruntId]"></p-button>
                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="7" class="text-center p-4">
                                            <div class="flex flex-column align-items-center">
                                                <i class="pi pi-briefcase text-500 text-4xl mb-3"></i>
                                                <span>Aucun emprunt trouvé pour cet employé</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>
                        </div>
                    </div>
                </p-tabPanel>

                <!-- Emplacements Tab -->
                <p-tabPanel leftIcon="pi pi-map-marker">
                    <ng-template pTemplate="header">
                        <i class="pi pi-map-marker mr-2"></i>
                        <span>Emplacements</span>
                        <div style="min-width: 2rem">
                            <p-badge *ngIf="emplacementsEmploye && emplacementsEmploye.length > 0"
                                [value]="emplacementsEmploye.length" severity="info" styleClass="ml-2 relative"></p-badge>
                        </div>
                    </ng-template>

                    <div class="grid">
                        <div class="col-12">
                            <div class="flex justify-content-between align-items-center mb-3">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text"
                                        (input)="dtEmplacements.filterGlobal($event.target.value, 'contains')"
                                        placeholder="Rechercher..." />
                                </span>
                                <p-button *ngIf="estAutorise('emplacement_modifier')" label="Ajouter une attribution" icon="pi pi-plus" (click)="ajouterEmplacement()"></p-button>
                            </div>
                            <p-table [value]="emplacementsEmploye" [loading]="chargementEmplacements" [paginator]="true"
                                [rows]="10" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} emplacements"
                                [globalFilterFields]="['emplacement.code', 'emplacement.nom']"
                                #dtEmplacements>

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="emplacement.code">
                                            Code <p-sortIcon field="emplacement.code"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="emplacement.nom">
                                            Nom <p-sortIcon field="emplacement.nom"></p-sortIcon>
                                        </th>
                                        <th>Attributs</th>
                                        <th style="width: 8rem">Actions</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-membre>
                                    <tr>
                                        <td>{{ membre.emplacement?.code }}</td>
                                        <td>{{ membre.emplacement?.nom }}</td>
                                        <td>
                                            <div class="flex flex-wrap gap-2">
                                                <p-tag *ngIf="membre.indAjoutAuto" value="Emplacement réel (Division)"
                                                    severity="success"></p-tag>
                                                <p-tag *ngIf="membre.indChargeProjet" value="Chargé de projet"
                                                    severity="success"></p-tag>
                                                <p-tag *ngIf="membre.indResponsable" value="Responsable"
                                                    severity="info"></p-tag>
                                                <p-tag *ngIf="membre.indReceptionRapportJournalier"
                                                    value="Reception de rapports journaliers" severity="warning"></p-tag>
                                                <p-tag *ngIf="membre.indReceptionPriseHeures"
                                                    value="Reception de prise des heures/kms" severity="warning"></p-tag>
                                                @if (membre.indReceptionEntreesSorties) {
                                                    <p-tag value="Réception entrées/sorties" severity="warning"></p-tag>
                                                }
                                                <p-tag *ngIf="membre.indSst" value="Responsable SST" severity="danger"></p-tag>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="flex gap-2">
                                                <p-button *ngIf="estAutorise('emplacement_modifier')" icon="pi pi-pencil" 
                                                    severity="secondary" (click)="modifierAttributsEmplacement(membre)" pTooltip="Modifier les attributions"></p-button>
                                                <p-button *ngIf="estAutorise('emplacement_modifier')" icon="pi pi-trash" 
                                                    severity="danger" (click)="supprimerEmplacement(membre)" pTooltip="Retirer de l'emplacement"></p-button>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="4" class="text-center p-4">
                                            <div class="flex flex-column align-items-center">
                                                <i class="pi pi-map-marker text-500 text-4xl mb-3"></i>
                                                <span>Aucun emplacement associé à cet employé</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>
                        </div>
                    </div>
                </p-tabPanel>

                <!-- Settings Tab -->
                <p-tabPanel
                    *ngIf="(employe.employeId == profilService.ProfilCourant().employeId || estAutorise('employe_modifier')) && employe.employeId != 0">
                    <ng-template pTemplate="header">
                        <i class="pi pi-cog mr-2"></i>
                        <span>Paramètres</span>
                    </ng-template>

                    <div class="grid">
                        <div class="col-12">
                            <p-card>
                                <h6 class="mb-4 text-primary-600 font-semibold">Préférences d'affichage</h6>
                                <div class="flex flex-column gap-4">
                                    <div class="flex flex-column gap-2">
                                        <div class="grid">
                                            <div class="col-12 md:col-6 flex flex-column gap-2">
                                                <label for="indVoirPhotoSurSurvole" class="font-medium">
                                                    Aperçu agrandi au survol
                                                </label>
                                                <small class="text-500">
                                                    Lorsque cette option est activée, survoler une image dans les listes
                                                    d'items affichera un aperçu agrandi.
                                                </small>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <p-selectButton [options]="[
                                                            {label: 'Activé', value: true},
                                                            {label: 'Désactivé', value: false}
                                                            ]" [(ngModel)]="employe.indVoirPhotoSurSurvole"
                                                    inputId="indVoirPhotoSurSurvole" (onChange)="sauvegarder()">
                                                </p-selectButton>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <div class="grid">
                                            <div class="col-12 md:col-6 flex flex-column gap-2">
                                                <label for="indVoirPhotoSurSurvole" class="font-medium">
                                                    Thème
                                                </label>
                                                <small class="text-500">
                                                    Choisir le thème d'affichage de l'interface de SIHC.
                                                </small>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <p-dropdown [options]="themes" [(ngModel)]="currentTheme"
                                                    optionLabel="name" optionValue="value"
                                                    (onChange)="onThemeChange($event); sauvegarder()"
                                                    [style]="{'min-width': '140px'}" placeholder="Thème"
                                                    [showClear]="false">
                                                    <ng-template pTemplate="selectedItem" let-selectedOption>
                                                        <div class="flex align-items-center gap-2"
                                                            *ngIf="selectedOption">
                                                            <div class="theme-dot"
                                                                [style]="{'background-color': selectedOption.color}"
                                                                [class.theme-dot-dark]="selectedOption.isDark">
                                                            </div>
                                                            <span>{{ selectedOption.name }}</span>
                                                        </div>
                                                    </ng-template>
                                                    <ng-template pTemplate="item" let-option>
                                                        <div class="flex align-items-center gap-2">
                                                            <div class="theme-dot"
                                                                [style]="{'background-color': option.color}"
                                                                [class.theme-dot-dark]="option.isDark">
                                                            </div>
                                                            <span>{{ option.name }}</span>
                                                        </div>
                                                    </ng-template>
                                                </p-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <div class="grid">
                                            <div class="col-12 md:col-6 flex flex-column gap-2">
                                                <label for="indCouleursFond" class="font-medium">
                                                    Couleurs d'arrière-plan
                                                </label>
                                                <small class="text-500">
                                                    Lorsque cette option est activée, les dégradés vert et bleu
                                                    s'affichent derrière les cartes en thème sombre.
                                                </small>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <p-selectButton [options]="[
                                                            {label: 'Activé', value: true},
                                                            {label: 'Désactivé', value: false}
                                                            ]" [(ngModel)]="employe.indCouleursFond"
                                                    inputId="indCouleursFond" (onChange)="sauvegarder()">
                                                </p-selectButton>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <div class="grid">
                                            <div class="col-12 md:col-6 flex flex-column gap-2">
                                                <label for="indVoirPhotoSurSurvole" class="font-medium">
                                                    Syncronisation de l'emplacement réel
                                                </label>
                                                <small class="text-500">
                                                    Lorsque cette option est activée, l'emplacement réel sera
                                                    synchronisé selon la division de l'employé dans le Portail Hamel. À
                                                    noter que cela ne s'applique pas aux membres d'emplacements ajoutés
                                                    manuellement.
                                                </small>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <p-selectButton [options]="[
                                                            {label: 'Activé', value: true},
                                                            {label: 'Désactivé', value: false}
                                                            ]" [(ngModel)]="employe.indAjouteAuChantier"
                                                    inputId="indAjouteAuChantier" (onChange)="sauvegarder()">
                                                </p-selectButton>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <div class="grid">
                                            <div class="col-12 md:col-6 flex flex-column gap-2">
                                                <label for="indSyncAutoBonCommande" class="font-medium">
                                                    Syncronisation automatique des bons de commande
                                                </label>
                                                <small class="text-500">
                                                    Si cette option est activée, les bons de commande seront
                                                    syncronisés automatiquement vers CTRL lors de chaque
                                                    modification ou ajout. Si l'option est désactivée, vous devrez
                                                    lancer une syncronisation manuellement pour toute modification à
                                                    un bon de commande.
                                                </small>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <p-selectButton [options]="[
                                                            {label: 'Activé', value: true},
                                                            {label: 'Désactivé', value: false}
                                                            ]" [(ngModel)]="employe.indSyncAutoBonCommande"
                                                    inputId="indSyncAutoBonCommande" (onChange)="sauvegarder()">
                                                </p-selectButton>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex flex-column gap-2">
                                        <div class="grid">
                                            <div class="col-12 md:col-6 flex flex-column gap-2">
                                                <label for="indVoirPhotoSurSurvole" class="font-medium">
                                                    Notifications système
                                                </label>
                                                <small class="text-500">
                                                    Lorsque cette option est activée, les notifications seront affichées dans le système d'exploitation.
                                                </small>
                                            </div>
                                            <div class="col-12 md:col-6">
                                                <p-button *ngIf="Notification.permission !== 'granted'" pRipple label="Activer les notifications système" icon="pi pi-bell" (click)="activerNotificationsSysteme()"></p-button>
                                                @if (Notification.permission === 'granted') {
                                                    <span>Les notifications système sont <b>activées</b>. Voici comment les désactiver: <a href="https://support.google.com/chrome/answer/3220216?hl=fr&co=GENIE.Platform%3DDesktop&oco=0" target="_blank">https://support.google.com/chrome/answer/3220216?hl=fr&co=GENIE.Platform%3DDesktop&oco=0</a></span>
                                                }
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </p-card>
                        </div>
                    </div>
                </p-tabPanel>

                <!-- Future tabs can be added here for other employee-related features -->

            </p-tabView>
        </p-card>
    </div>
</div>

<!-- Role Addition Dialog -->
<p-dialog [(visible)]="dialogAjoutRolesVisible" [style]="{width: '50vw'}" header="Ajouter des rôles" [modal]="true"
    styleClass="p-fluid">

    <div class="fluid formgrid grid">
        <div class="col-12">
            <p-table #dt [value]="rolesDisponibles" [rows]="10" [paginator]="true"
                [globalFilterFields]="['name', 'description']" [(selection)]="rolesAjoutSelectionnes" dataKey="roleId"
                styleClass="p-datatable-sm" [rowHover]="true" [showCurrentPageReport]="true"
                currentPageReportTemplate="{first} à {last} sur {totalRecords} rôles" [rowsPerPageOptions]="[10,25,50]">
                <ng-template pTemplate="caption">
                    <span class="p-input-icon-left w-full">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" placeholder="Rechercher un rôle..."
                            (input)="dt.filterGlobal($event.target.value, 'contains')" class="w-full" />
                    </span>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="name">Nom <p-sortIcon field="name"></p-sortIcon></th>
                        <th style="width: 5rem">Actions</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-role>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="role"></p-tableCheckbox>
                        </td>
                        <td>{{role.nom}}</td>
                        <td>
                            <button pButton pRipple icon="pi pi-list"
                                class="p-button-rounded p-button-info p-button-text" pTooltip="Voir les tâches"
                                (click)="voirTachesRole(role)"
                                [disabled]="!role.taches || role.taches.length === 0"></button>
                        </td>
                    </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4" class="text-center p-4">
                            <div class="flex flex-column align-items-center">
                                <i class="pi pi-info-circle text-500 text-4xl mb-3"></i>
                                <span>Aucun rôle disponible</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Annuler" icon="pi pi-times" class="p-button-outlined"
            (click)="fermerDialogueAjoutRoles()"></button>
        <button pButton pRipple label="Ajouter" icon="pi pi-check" class="p-button-primary"
            [disabled]="!rolesAjoutSelectionnes || rolesAjoutSelectionnes.length === 0"
            (click)="ajouterRolesSelectionnes()"></button>
    </ng-template>
</p-dialog>

<!-- Tasks Display Dialog -->
<p-dialog [(visible)]="dialogTachesVisible" [style]="{width: '50vw'}"
    [header]="'Tâches associées au rôle: ' + roleSelectionne?.nom" [modal]="true" styleClass="p-fluid">

    <div class="fluid formgrid grid">
        <div class="col-12">
            <p-card *ngIf="roleSelectionne?.taches && roleSelectionne.taches.length > 0">
                <div class="flex flex-column gap-3" style="max-height: 50vh; overflow-y: auto">
                    <div *ngFor="let tache of roleSelectionne.taches"
                        class="flex align-items-center justify-content-between p-3 border-1 border-200 border-round">
                        <div class="flex flex-column gap-1">
                            <div class="flex align-items-center gap-2">
                                <i class="pi pi-check-circle text-primary"></i>
                                <span class="font-semibold text-900">{{tache.nom}}</span>
                            </div>
                            <small class="text-500 ml-4">Code: {{tache.code}}</small>
                        </div>
                    </div>
                </div>
            </p-card>

            <div *ngIf="!roleSelectionne?.taches || roleSelectionne.taches.length === 0" class="text-center p-4">
                <div class="flex flex-column align-items-center">
                    <i class="pi pi-info-circle text-500 text-4xl mb-3"></i>
                    <span>Aucune tâche associée à ce rôle</span>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="Fermer" icon="pi pi-times" class="p-button-outlined"
            (click)="fermerDialogueTaches()"></button>
    </ng-template>
</p-dialog>